import type { Market, Marketplace } from '@backmarket/http-api'
/** Create marketplace object grouping markets by marketplace code. */
export function createMarketplace(
  market: Market,
  allMarkets: Record<string, Market>,
): Marketplace {
  return {
    marketplaceCode: market.marketplace,
    markets: Object.values(allMarkets).filter((m) => {
      return m.marketplace === market.marketplace
    }),
  }
}
